import apiClient from './client'
import type { Vendor } from '@portal/types'

// Kept for backward compatibility with PaymentForm
export interface VendorOption {
  id: string
  name: string
  nickname?: string | null
  bankAccount: string
  bankIfsc: string
  category: string
  payeeType: string
}

export interface CreateVendorPayload {
  name: string
  nickname?: string
  gstin?: string
  bankAccount: string
  bankIfsc: string
  upiVpa?: string
  category: 'SUPPLIER' | 'CONTRACTOR' | 'UTILITY' | 'RENT' | 'OTHER'
}

export interface UpdateVendorPayload {
  name?: string
  nickname?: string
  gstin?: string
  bankAccount?: string
  bankIfsc?: string
  upiVpa?: string
  category?: 'SUPPLIER' | 'CONTRACTOR' | 'UTILITY' | 'RENT' | 'OTHER'
}

export interface VendorListParams {
  search?: string
  category?: string
  page?: number
  limit?: number
}

export interface VendorListResponse {
  success: boolean
  data: Vendor[]
  total: number
  page: number
  limit: number
}

export interface VendorDetailResponse {
  success: boolean
  data: VendorWithHistory
}

export interface BeneResult {
  beneId: string | null
  message?: string
  isValid?: boolean
}

export interface VendorWithHistory extends Vendor {
  paymentHistory: {
    id: string
    paymentMode: string
    amount: number
    status: string
    payeeName: string
    remarks?: string
    createdAt: string
    updatedAt: string
  }[]
}

export const vendorsApi = {
  list: (params?: VendorListParams | string) => {
    const queryParams = typeof params === 'string' ? { search: params } : params
    return apiClient.get('/api/vendors', { params: queryParams }) as unknown as Promise<VendorListResponse>
  },

  create: (payload: CreateVendorPayload) =>
    apiClient.post('/api/vendors', payload) as unknown as Promise<{ success: boolean; data: Vendor }>,

  get: (id: string) =>
    apiClient.get(`/api/vendors/${id}`) as unknown as Promise<VendorDetailResponse>,

  update: (id: string, payload: UpdateVendorPayload) =>
    apiClient.put(`/api/vendors/${id}`, payload) as unknown as Promise<{ success: boolean; data: Vendor }>,

  delete: (id: string) =>
    apiClient.delete(`/api/vendors/${id}`) as unknown as Promise<{ success: boolean; message: string }>,

  registerBene: (id: string) =>
    apiClient.post(`/api/vendors/${id}/register-bene`) as unknown as Promise<{ success: boolean; data: BeneResult }>,

  validateBene: (id: string) =>
    apiClient.post(`/api/vendors/${id}/validate-bene`) as unknown as Promise<{ success: boolean; data: BeneResult }>,
}
